import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { ContaReceberRequest, Response } from './Types';

class ContaReceberController {
  public static async Listar(request: ContaReceberRequest): Promise<Response> {
    try {
      console.log('REQUEST: ', request.vencimentoFinal)
      const response = await Api.post(`api/contareceber/Listar`, request);

      const object = response?.data;

      return { StatusCode: response.status, Data: object };
    } catch (error: any) {
      return {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
    }
  }

   public static async Salvar(request: any): Promise<Response> {
    try {
      console.log('REQUEST NO SALVAR, ', request)
      const response = await Api.post(`api/caixalancamento/Salvar`, request);

      const object = response?.data;

      return { StatusCode:response.status, Data: object };
    } catch (error: any) {
      return {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
    }
  }

  public static async Dashboard(request: ContaReceberRequest): Promise<Response> {
    try {
      const response = await Api.post(`api/contareceber/Dashboard`, request);

      const object = response?.data[0];

      return { StatusCode: response.status, Data: object };
    } catch (error: any) {
      return {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
    }
  }

  public static async Atualizar(request: ContaReceberRequest): Promise<Response> {
      try {
        console.log('Controller PARCElA Atualizar');
        console.log(request);
  
        const response = await Api.put(`api/contareceber/Atualizar`, request);
  
        const object = response?.data;
  
        const retorno: Response = { StatusCode: response.status, Data: object };
        return retorno;
      } catch (error: any) {
        const retorno: Response = {
          StatusCode: error?.response?.status,
          Data: ErrorDictionary(error?.response?.status),
        };
        return retorno;
      }
    }
  public static async Inserir(request: ContaReceberRequest): Promise<Response> {
    try {
      const response = await Api.post(`api/contareceber/Inserir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}



export default ContaReceberController;
